import { defineApiActionTypes } from 'utils/actionHelper';
const prefix = 'ui/containers/App';

export const SET_READ_NOTIFICATION = `${prefix}/SET_READ_NOTIFICATION`;

export const GET_INITIAL_STATE = defineApiActionTypes(`${prefix}/GET_INITIAL_STATE`);
export const GET_CHANNEL_ID = defineApiActionTypes(`${prefix}/GET_CHANNEL_ID`);
export const SET_PAGE = `${prefix}/SET_PAGE`;
export const GET_USER = defineApiActionTypes(`${prefix}/GET_USER`);
export const GET_USER_CONVERSATIONS_LIST = defineApiActionTypes(
  `${prefix}/GET_USER_CONVERSATIONS_LIST`
);

export const GET_ALL_FILES = defineApiActionTypes(`${prefix}/GET_ALL_FILES`);

export const GET_USER_CONVERSATION = defineApiActionTypes(`${prefix}/GET_USER_CONVERSATION`);
export const SET_ACTIVE_PAGE = defineApiActionTypes(`${prefix}/SET_ACTIVE_PAGE`);
export const UPDATE_CONVERSATION_MESSAGES = defineApiActionTypes(
  `${prefix}/UPDATE_CONVERSATION_MESSAGES`
);
export const REMOVE_FROM_CONVERSATION_MESSAGES = defineApiActionTypes(
    `${prefix}/REMOVE_FROM_CONVERSATION_MESSAGES`
);

export const HIDE_REMOVABLE_MESSAGES = defineApiActionTypes(
    `${prefix}/HIDE_REMOVABLE_MESSAGES`
);

export const SET_AGENT_NEW_MESSAGE_LIST = `${prefix}/SET_AGENT_NEW_MESSAGE_LIST`;

export const CREATE_NEW_CONVERSATION = defineApiActionTypes(`${prefix}/CREATE_NEW_CONVERSATION`);

export const SET_CURRENT_CHANNEL = `${prefix}/SET_CURRENT_CHANNEL`;

export const SET_USER_ATTACHMENTS = `${prefix}/SET_USER_ATTACHMENTS`;

export const SET_INITIATE_SOCKET_CONNECTION = `${prefix}/SET_INITIATE_SOCKET_CONNECTION`;

export const SET_SEND_GREETING_MESSAGE_ACTION = `${prefix}/SET_SEND_GREETING_MESSAGE_ACTION`;

export const GET_RECENT_GIFS = defineApiActionTypes(`${prefix}/GET_RECENT_GIFS`);

export const GET_TRENDING_GIFS = defineApiActionTypes(`${prefix}/GET_TRENDING_GIFS`);

export const GET_SEARCHED_GIFS = defineApiActionTypes(`${prefix}/GET_SEARCHED_GIFS`);

export const CLEAR_USER_CONVERSATION = `${prefix}/CLEAR_USER_CONVERSATION`;

export const PROCESS_PUSHER_MESSAGES = `${prefix}/PROCESS_PUSHER_MESSAGES`;

export const PROCESS_CLIENT_MESSAGES = `${prefix}/PROCESS_CLIENT_MESSAGES`;

export const SET_USER_CONVERSATION_DATA = `${prefix}/SET_USER_CONVERSATION_DATA`;

export const SET_USER_ID = `${prefix}/SET_USER_ID`;

export const SET_PRIMARY_COLOR = `${prefix}/SET_PRIMARY_COLOR`;

export const SET_SECONDARY_COLOR = `${prefix}/SET_SECONDARY_COLOR`;

export const SET_LOGO_URL = `${prefix}/SET_LOGO_URL`;

export const SET_LANGUAGE = `${prefix}/SET_LANGUAGE`;

export const SET_BOT_NAME = `${prefix}/SET_BOT_NAME`;

export const SET_HIDE_COMPANY_DETAILS_IN_WIDGET = `${prefix}/SET_HIDE_COMPANY_DETAILS_IN_WIDGET`;

export const SET_NETWORK_STATUS = `${prefix}/SET_NETWORK_STATUS`;

export const SET_SERVER_MESSAGES_QUEUE = `${prefix}/SET_SERVER_MESSAGES_QUEUE`;

export const SET_IS_MESSAGE_UNREAD = `${prefix}/SET_IS_MESSAGE_UNREAD`;

export const SET_IS_PUSHER_CONNECTED = `${prefix}/SET_IS_PUSHER_CONNECTED`;

export const SET_DELAY_FLAG = `${prefix}/SET_DELAY_FLAG`;

export const UPDATE_SENDING_MESSAGES = defineApiActionTypes(`${prefix}/UPDATE_SENDING_MESSAGES`);

export const REMOVE_FROM_SENDING_MESSAGES = `${prefix}/REMOVE_FROM_SENDING_MESSAGES`;

export const HANDLE_SENDING_MESSAGES_TO_PUSHER = `${prefix}/HANDLE_SENDING_MESSAGES_TO_PUSHER`;

export const HANDLE_SENDING_COOKIES_TO_PUSHER = `${prefix}/HANDLE_SENDING_COOKIES_TO_PUSHER`;

export const UPDATE_MESSAGE_READ_STATUS = `${prefix}/UPDATE_MESSAGE_READ_STATUS`;

export const UPDATE_MESSAGE_DELIVERED = `${prefix}/UPDATE_MESSAGE_DELIVERED`;

export const CLEAR_ACTIVE_MESSAGES = `${prefix}/CLEAR_ACTIVE_MESSAGES`;

export const SET_INPUT_BOX_STATUS = `${prefix}/SET_INPUT_BOX_STATUS`;

export const SET_AGENT = `${prefix}/SET_AGENT`;

export const HIDE_RESTART_BUTTON = `${prefix}/HIDE_RESTART_BUTTON`;

export const WIDGET_SOUND = `${prefix}/WIDGET_SOUND`;

export const SET_EXTERNAL_TRIGGER_FORMS = `${prefix}/SET_EXTERNAL_TRIGGER_FORMS`;
export const SET_EXTERNAL_TRIGGER_ELEMENTS = `${prefix}/SET_EXTERNAL_TRIGGER_ELEMENTS`;
export const SET_MAPPED_FORM_FIELDS = `${prefix}/SET_MAPPED_FORM_FIELDS`;
export const SET_CUSTOM_COOKIES = `${prefix}/SET_CUSTOM_COOKIES`;

export const SET_SHOW_TYPING = `${prefix}/SET_SHOW_TYPING`;
export const SHOW_TYPING_INDICATOR = `${prefix}/SHOW_TYPING_INDICATOR`;

export const SET_TIME_SPENT = defineApiActionTypes(`${prefix}/SET_TIME_SPENT`);

export const SET_CLIENT_SENT_TIME = `${prefix}/SET_CLIENT_SENT_TIME`;

export const SET_SERVER_RESPONSE_TIME = `${prefix}/SET_SERVER_RESPONSE_TIME`;

export const RESET_NETWORK_DELAY = `${prefix}/RESET_NETWORK_DELAY`;

export const TEXT_AREA_NUMBER_OF_LINES = `${prefix}/TEXT_AREA_NUMBER_OF_LINES`;
export const CLEAR_BOT_ACTIVE_PATH = `${prefix}/CLEAR_BOT_ACTIVE_PATH`;

export const SET_LINK_IFRAME = defineApiActionTypes(`${prefix}/SET_LINK_IFRAME`);

export const PUSHER_STATES = {
  connected: 'connected',
  connecting: 'connecting',
  unavailable: 'unavailable',
  offline: 'offline',
  online: 'online',
};

export const PUSHER_EVENT_TYPES = {
  newMessage: 'new-message',
  popupMessage: 'popup-message',
  appUserConnected: 'app-user-connected',
};

export const NATIVE_NOTIFICATION_VARIANT = {
  success: 'success',
  error: 'error',
};

export const NETWORK_STATUS = {
  online: 'online',
  offline: 'offline',
};

export const MESSAGE_TYPES = {
  text: 'text',
  link: 'link',
  buttons: 'buttons',
  gif: "gif",
  attachments: 'attachments',
  preview: 'preview',
  input: {
    val: 'input',
    email: 'email',
    plain: 'plain',
    phone: 'phone',
    picklist: 'picklist',
  },
  plainInput: 'plainInput',
  event: 'event',
  notification: 'notification',
  zendeskCreateTicket: 'zendeskCreateTicket',
  zendeskSearchKnowledgeBase: 'zendeskSearchKnowledgeBase',
  feedback: 'feedback',
  calendar: 'calendar',
  serviceCloudCreateTicket: 'serviceCloudCreateTicket',
  serviceCloudKnowledgeBase: 'serviceCloudKnowledgeBase',
};

export const WINDOW_POSTMESSAGE_TYPES = {
  iframeResize: 'iframe-resize',
  initialData: 'initial-data',
  getCustomCookies: 'get-custom-cookies',
  sendCustomCookies: 'send-custom-cookies',
  iframeFocus: 'iframe-focus',
  pageFocus: 'page-focus',
  pageBlur: 'page-blur',
  triggerForm: 'trigger-form',
  triggerElement: 'trigger-element',
  mappedFormFields: 'mapped-form-fields',
  isSessionActive: 'sessionIsActive',
  sessionNotActive: 'sessionNotActive',
  formSubmit: 'form-submit',
  changePage: 'change-page',
  clickElementSubmit: 'click-element-submit',
  widgetVisibility: 'widget-visibility',
  widgetExpand: 'widget-expand',
  widgetMinimize: 'widget-minimize',
  widgetEvent: 'widgetEvent',
  showConversation: 'show-conversation',
  triggerEvent: 'triggerEvent',
  websiteForm: 'websiteform-submitted',
  titleBarAlert: 'titleBarAlert',
  clearLocalStorage: 'clearLocalStorage',
  hyperlinkRedirect: 'hyperlinkRedirect',
};

export const TRIGGER_EVENT_TYPES = {
  startConversation: 'startConversation',
  greetingMessageClosed: 'greetingMessageClosed',
  emailCapture: 'emailCapture',
  phoneNumberCapture: 'phoneNumberCapture',
  calendarBooked: 'calendarBooked',
  calendarLinkClicked: 'calendarLinkClicked',
  buttonClicked: 'buttonClicked',
};

export const TITLEBAR_ALERT_STATUS = {
  set: 'set',
  clear: 'clear',
};

export const SENDING_MESSAGE_TYPE = {
  bot: 'bot',
  message: 'message',
  cookies: 'cookies',
};

export const MAX_FILE_SIZE = 30000000;

export const SET_PARENT_INNER_WIDTH = `${prefix}/SET_PARENT_INNER_WIDTH`;

export const SET_POPUP_TO_NOTIFICATION_MESSAGE = `${prefix}/SET_POPUP_TO_NOTIFICATION_MESSAGE`;

export const SET_WIDGET_VISIBILITY = `${prefix}/SET_WIDGET_VISIBILITY`;

export const HANDLE_WIDGET_EVENT = `${prefix}/HANDLE_WIDGET_EVENT`;

export const FETCH_MEETING_SLOTS =  `${prefix}/FETCH_MEETING_SLOTS`;

export const BOOK_MEETING_SLOT =  `${prefix}/BOOK_MEETING_SLOT`;

